<div class="matero-auth-container">
  <router-outlet></router-outlet>
  <div class="build-info" [ngStyle]="{ color: '#fff' }">
    {{ buildInfo }}
  </div>
</div>
